import React from "react";
import { ArrowClockwise, ArrowLeft, WarningCircle } from "@phosphor-icons/react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep production users out of a blank screen while preserving a useful console trace.
    console.error("Callsect UI error", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="app-crash-page" role="alert">
        <section className="app-crash-card">
          <span className="app-crash-card__icon" aria-hidden="true">
            <WarningCircle size={26} weight="duotone" />
          </span>
          <div className="brand-eyebrow">Something went wrong</div>
          <h1>This view could not be displayed.</h1>
          <p>
            Your data has not been changed. Reload this page, or return to the previous
            screen and try again.
          </p>
          <div className="app-crash-card__actions">
            <button type="button" onClick={() => window.location.reload()}>
              <ArrowClockwise size={16} weight="bold" />
              Reload page
            </button>
            <button type="button" className="is-secondary" onClick={() => window.history.back()}>
              <ArrowLeft size={16} weight="bold" />
              Go back
            </button>
          </div>
        </section>
      </main>
    );
  }
}
